import { mutatorAction } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';

export const dismissPromptActionCard = mutatorAction('DISMISS_PROMPT_ACTION_CARD', () => {
    getActivityFeedStore().feedAction.promptFeedAction = false;
});
